import * as React from 'react';
import Link from '@mui/joy/Link';
import SwaggerUI from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css";
import "../../assets/css/swagger-joy.css";
import { getAuthHeader } from '../../lib/client';
import Box from '@mui/joy/Box';
import Typography from '@mui/joy/Typography';

export default function SwaggerPage({ error, setError }) {
  const addAuthHeader = async (req) => {

    let header = await getAuthHeader();
    if (header && req.headers) {
      Object.assign(req.headers, header);
    } else {
      setError(<><Link href="/login" sx={{ color: '#fff' }}>Login</Link> to try out the API</>);
    }
    return (req);
  };


  return (
    <Box sx={{ pt: 'var(--Header-height)' }}>
      <Box sx={{ display: { xs: 'block', sm: 'none' }, px: 2, py: 2 }}>
        <Typography level="title-md">API docs</Typography>
        <Typography level="body-sm" color="neutral">
          The interactive Swagger UI is available on desktop.
        </Typography>
      </Box>
      <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
        <SwaggerUI
          url={`${process.env.REACT_APP_BACKEND_SERVER}/api/api-docs`}
          tryItOutEnabled={false}
          deepLinking={true}
          displayOperationId={true}
          displayRequestDuration={true}
          requestInterceptor={addAuthHeader}
        />
      </Box>
    </Box>
  );
};
